import React from 'react';
import './Contact.css';

const contactItems = [
    { label: 'Telefon', value: '+40 752 875 121', href: 'tel:+40752875121' },
    { label: 'E-mail', value: 'contact@evoomedical.ro', href: 'mailto:contact@evoomedical.ro' },
    { label: 'Adresă', value: 'Sebeș, loc. Petrești, str. 1 Mai nr. 294, jud. Alba' },
    { label: 'Program', value: 'Luni – sâmbătă, 07:00 – 21:00' },
];

function Contact() {
    return (
        <main>
            <header className="contact-hero">
                <span className="contact-eyebrow">Informații legale</span>
                <h1>Contact</h1>
                <p className="contact-intro">Ne puteți suna, scrie sau veni la clinică în programul de lucru.</p>
            </header>

            <section className="contact-body">
                <div className="contact-grid">
                    {contactItems.map((item) => (
                        <div className="contact-card" key={item.label}>
                            <span className="contact-label">{item.label}</span>
                            <p className="contact-value">
                                {item.href ? <a href={item.href}>{item.value}</a> : item.value}
                            </p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
}

export default Contact;
